document.addEventListener('DOMContentLoaded', () => {
  const ring = document.getElementById('cursor-ring');
  const SIZE = 25;

  console.log('ring');

  let mouseX = 0,
    mouseY = 0;
  let ringX = 0,
    ringY = 0;
  const LERP = 0.12;

  document.addEventListener('mousemove', (e) => {
    mouseX = e.clientX;
    mouseY = e.clientY;
  });

  function animate() {
    ringX += (mouseX - ringX) * LERP;
    ringY += (mouseY - ringY) * LERP;

    ring.style.transform = `translate(${ringX - SIZE}px, ${ringY - SIZE / 2}px)`;

    requestAnimationFrame(animate);
  }
  animate();

  document.addEventListener('mouseleave', () => (ring.style.opacity = '0'));
  document.addEventListener('mouseenter', () => (ring.style.opacity = '1'));
});
